import React from 'react';
import './FilterPanel.scss';
import Label from '../../ui-elements/Label';
import Minimap from '../../compositions/Minimap/Minimap';
import ApplyFiltersButton from '../../compositions/ApplyFiltersButton/ApplyFiltersButton';

const FilterPanelExample = () => {
  return (
    <div className="filter regional-filter">
      <h3>Filter</h3>

      <Label htmlFor="regions" textContent="Klimaregionen" toolTip="Hier können Sie mit Hilfe der Karte die Analyse der jeweiligen Klimaregion auswählen." />

      <Minimap />

      <ApplyFiltersButton />
    </div>
  );
};

export default FilterPanelExample;
